import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.tips.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-tips-dashboard',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.tips.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminTipsDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public data: any = {
        counts: { total: 0, recommended: 0, selected: 0, graduated: 0 },
        total_investment: 0,
        rows: []
    };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call('summary');
        if (code == 200) this.data = data.data || data;
        this.loaded = true;
        await this.service.render();
    }

    public goList(status: string) {
        this.service.href(`/admin/tips/company/${status}`);
    }

    public formatMoney(value: any): string {
        const amount = Number(value) || 0;
        if (!amount) return '-';
        return amount.toLocaleString() + '원';
    }
}

export default PortalLpsysadminTipsDashboardComponent;